/**
 * Normalizes a string for comparison by removing diacritics, special characters,
 * converting to lowercase, and collapsing whitespace.
 *
 * Used for matching search keywords against fulltext transcripts where the backend
 * search service has already normalized the indexed content.
 *
 * @param {string} str - The string to normalize
 * @returns {string} - Normalized string suitable for comparison
 *
 * @example
 * normalizeForMatching("Francisco y Dolores ↔ María Getra")
 * // Returns: "francisco y dolores maria getra"
 */
export function normalizeForMatching(str) {
  if (!str) return ''

  // Step 1: Remove diacritics using Unicode NFD normalization
  // "María" → "Maria", "François" → "Francois"
  const withoutDiacritics = str.normalize('NFD').replaceAll(/[\u0300-\u036f]/g, '')

  // Step 2: Remove all non-alphanumeric characters except spaces
  // "Francisco ↔ Maria" → "Francisco  Maria"
  const alphanumericOnly = withoutDiacritics.replaceAll(/[^\p{L}\p{N}\s]/gu, '')

  // Step 3: Convert to lowercase
  const lowercase = alphanumericOnly.toLowerCase()

  // Step 4: Collapse multiple spaces and trim
  return lowercase.replaceAll(/\s+/g, ' ').trim()
}
